import { useEffect, useState } from "react";
import TextInput from "../TextInput/TextInput";
import ButtonGroup from "../ButtonGroup/ButtonGroup";
import { MdAutorenew, MdContentCopy } from "react-icons/md";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { generatePassword, showNotification } from "../../helpers/utils";
import useMobile from "src/hooks/useMobile";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

interface IPasswordGenerator {
  policiesToValidate?: Array<any>;
  userSelected?: Array<any>;
  onChange: (password: string) => void;
}

const PasswordGenerator: React.FC<IPasswordGenerator> = ({
  policiesToValidate = [],
  userSelected = [],
  onChange,
}) => {
  const [generatedPassword, setGeneratedPassword] =
    useState<string>(generatePassword());
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  useEffect(() => {
    onChange(generatedPassword);
  }, [generatedPassword]);

  return (
    <div className={clsx(["flex", "md:flex-row", "gap-4"])}>
      <TextInput
        value={generatedPassword}
        onChange={(e: any) => setGeneratedPassword(e?.target?.value)}
        readOnly
      />
      <ButtonGroup
        gap={1}
        align="right"
        buttons={[
          {
            text: t("common:buttons.generate"),
            onClick: () => setGeneratedPassword(generatePassword()),
            icon: <MdAutorenew size={ICON_SIZES.MD} />,
            kind: EButtonKind.NORMAL,
          },
          {
            text: isMobile ? "" : t("common:tooltips.copy"),
            onClick: async () => {
              try {
                await navigator.clipboard.writeText(generatedPassword);
                showNotification({
                  message: t("misc:strings.copied_to_clipboard"),
                  kind: "success",
                });
              } catch (err) {
                showNotification({
                  message: t("Error copiando la contraseña"),
                  kind: "error",
                });
              }
            },
            icon: <MdContentCopy size={ICON_SIZES.MD} />,
          },
        ]}
      />
    </div>
  );
};

export default PasswordGenerator;
